export default __webpack_public_path__ + "static/0094-350c6ee4b2577f9c56974c852122f2e9.png";